import * as actionTypes from 'src/old/actions';

const initialState = {
  currentCompany: {
    company: null,
    withdrawals: [],
    withdrawalsPaginated: {
      data: [],
      meta: {}
    }
  },
  insights: {}
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY: {
      return {
        ...state,
        currentCompany: { ...state.currentCompany, company: action.response }
      };
    }
    case actionTypes.FETCH_COMPANY_WITHDRAWALS_PAGINATED: {
      return {
        ...state,
        currentCompany: {
          ...state.currentCompany,
          withdrawalsPaginated: action.response
        }
      };
    }

    case actionTypes.FETCH_COMPANY_INSIGHTS: {
      return {
        ...state,
        insights: action.response
      };
    }

    case actionTypes.PUT_COMPANY_SETTINGS: {
      return {
        ...state,
        currentCompany: {
          company: {
            ...state.currentCompany.company,
            settings: action.response
          },
          ...state.currentCompany
        }
      };
    }

    case actionTypes.CLEAR_CURRENT_COMPANY_DATA: {
      return {
        ...state,
        currentCompany: initialState.currentCompany
      };
    }

    default: {
      return state;
    }
  }
};

export default companyReducer;
